module.exports = __webpack_public_path__ + "assets/USDT(BEP20).3e8567dc.svg";